const faqs = [
  {
    id: 1,
    question: '如何开始在九妖漫画网阅读漫画？',
    answer: '直接在浏览器中打开九妖漫画网即可开始免费阅读！无需注册账号，在首页选择您感兴趣的漫画分类或直接搜索作品名称，点击漫画封面进入阅读页面，即可享受极速下拉式免费漫画阅读体验。',
  },
  {
    id: 2,
    question: '九妖漫画网需要注册或付费吗？',
    answer: '完全不需要！九妖漫画网是全免费的漫画在线阅读平台，所有漫画资源均可免费阅读全集，无需注册、无需付费、无需订阅。我们坚持免费下拉式漫画阅读理念，让每一位漫画爱好者无门槛享受阅读乐趣。',
  },
  {
    id: 3,
    question: '支持哪些设备阅读漫画？',
    answer: '九妖漫画网完美适配桌面电脑、平板和手机等各类设备。无论是在家使用电脑大屏享受高清漫画画面，还是在外用手机碎片化追更，均能获得流畅的下拉式阅读体验。所有设备无需下载额外软件，打开浏览器即可阅读。',
  },
  {
    id: 4,
    question: '漫画每天什么时候更新？',
    answer: '九妖漫画网每日与各大漫画平台同步更新最新章节，通常在每天上午至中午时段集中更新。热门连载漫画如《斗破苍穹》《海贼王》等几乎每日都有更新，建议收藏喜欢的漫画以便第一时间获取免费追更提醒。',
  },
  {
    id: 5,
    question: '如何快速找到我想看的漫画？',
    answer: '您可以通过多种方式快速找到心仪的漫画：使用搜索功能输入漫画名称或作者名；浏览首页热门话题分类标签（热血、恋爱、玄幻等）；查看精选推荐漫画卡片；或访问漫画大全索引中的国漫推荐、日漫精选、韩漫热门专区，分类明确，查找便捷。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            关于九妖漫画网免费漫画阅读的常见疑问解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto divide-y divide-background-200">
          {faqs.map((faq) => (
            <div key={faq.id} className="py-5 md:py-6">
              <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}